<template>
 <form class="ui form" id="new-doctor-form">
   <div v-if="loading" class="ui active inline center inverted dimmer">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <div class="centered-header">
      <h2 class="ui header" style="color: #092442;">
        <i class="address card outline icon"></i>
        <div class="content">
          {{ $t('newDoctor') }}
        </div>
      </h2>
    </div>

    <br>

    <h4 class="ui dividing header">
      {{ $t('personalInfo') }}
    </h4>
    <div class="required field">
      <label for="name">{{ $t('name') }}</label>
      <div class="ui input">
        <input type="text"
               :placeholder="$t('doctorName')"
               v-model="doctor.name"
               name="name">
      </div>
    </div>

    <div class="required two fields">
      <div class="field">
        <label for="date_of_birth">{{ $t('dateOfBirth') }}</label>
        <div style="text-align: center" class="ui calendar" :id="'doctor-date-of-birth'">
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input type="text"
                   :placeholder="$t('dateOfBirth')"
                   readonly=""
                   name="day">
          </div>
        </div>
      </div>

      <div class="field">
        <label for="gender">{{ $t('chooseGender') }}</label>
        <select class="ui fluid search dropdown"
                id="gender-search"
                v-model="doctor.gender"
                name="gender">
          <option value="">{{ $t('chooseEmployeeGender') }}</option>
          <option :value="1">{{ $t('male') }}</option>
          <option :value="2">{{ $t('female') }}</option>
        </select>
      </div>
    </div>

    <div class="required two fields">
      <div class="field">
        <label for="nationalId">{{ $t('nationalId') }}</label>
        <div class="ui input left icon">
          <i class="address card icon"></i>
          <input type="number"
                 :placeholder="$t('nationalId')"
                 v-model="doctor.job_info.national_id"
                 name="nationalId">
        </div>
      </div>

      <div class="field">
        <label for="chooseMaritalStatus">{{ $t('chooseMaritalStatus') }}</label>
        <select class="ui fluid search dropdown"
                id="marital-status-search"
                v-model="doctor.job_info.marital_status"
                name="maritalStatus">
          <option value="">{{ $t('chooseMaritalStatus') }}</option>
          <option :value="1">{{ $t('married') }}</option>
          <option :value="2">{{ $t('single') }}</option>
        </select>
      </div>
    </div>

    <div class="two fields">
      <div class="field">
        <label for="telephone">{{ $t('phone') }}</label>
        <div class="ui input left icon">
          <i class="phone icon"></i>
          <input type="number"
                 :placeholder="$t('phone')"
                 v-model="doctor.home_phone"
                 name="homePhone">
        </div>
      </div>

      <div class="required field">
        <label for="cell_phone">{{ $t('cellPhone') }}</label>
        <div class="ui input left icon">
          <i class="mobile icon"></i>
          <input type="number"
                 :placeholder="$t('cellPhone')"
                 v-model="doctor.mobile"
                 name="cellPhone">
        </div>
      </div>
    </div>

    <div class="required field">
      <label for="address">{{ $t('address') }}</label>
      <textarea rows="2"
                :placeholder="$t('address')"
                v-model="doctor.address"
                name="address"></textarea>
    </div>

    <br/>
    <br/>

    <h4 class="ui dividing header">
      {{ $t('signUpInfo') }}
    </h4>
    <div class="required three fields">
      <div class="field">
        <label for="email">{{ $t('email') }}</label>
        <div class="ui input left icon">
          <i class="at icon"></i>
          <input type="email"
                 :placeholder="$t('email')"
                 v-model="doctor.email"
                 name="email">
        </div>
      </div>
      <div class="field">
        <label for="password">{{ $t('password') }}</label>
        <div class="ui input left icon">
          <i class="lock icon"></i>
          <input type="password"
                 :placeholder="$t('password')"
                 v-model="doctor.password"
                 name="password">
        </div>
      </div>
      <div class="field">
        <label for="password_confirmation">{{ $t('passwordConfirmation') }}</label>
        <div class="ui input left icon">
          <i class="lock icon"></i>
          <input type="password"
                 :placeholder="$t('passwordConfirmation')"
                 v-model="doctor.password_confirmation"
                 name="passwordConfirmation">
        </div>
      </div>

    </div>

    <br/>

    <h4 class="ui dividing header">
      {{ $t('jobInfo') }}
    </h4>

    <div class="required field" style="width: 50%">
      <label for="specialization">{{ $t('specialization') }}</label>
      <select class="ui fluid search dropdown"
              id="specialization-search"
              v-model="doctor.job_info.specialization.id"
              name="specialization">
        <option value="">{{ $t('specialization') }}</option>
        <option :value="specialization.id"
                v-for="specialization in specializations" :key="specialization.id">
          {{ specialization.name }}
        </option>
      </select>
    </div>

    <div class="ui blue right floated button" style="background-color: #092442" @click="submit()">
      {{ $t('submit') }}
    </div>
    <div class="ui error message"></div>
    <div v-if="notCreated" style="color: red">
      the record is not created some thing wrong with your data and here is a cause may your email is already used by another account.
    </div>
 </form>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      notCreated: false,
      doctor: {
        name: null,
        email: null,
        gender: null,
        date_of_birth: null,
        address: null,
        home_phone: null,
        mobile: null,
        password: null,
        password_confirmation: null,
        job_info: {
          national_id: null,
          marital_status: null,
          specialization: {
            id: null
          }
        }
      }
    }
  },
  mounted () {
    this.initGUI()
  },
  methods: {
    initGUI () {
      this.$nextTick(() => {
        $('#doctor-date-of-birth').calendar({
          type: 'date',
          onChange: (date) => {
            this.doctor.date_of_birth = date
          },
          isDisabled: (date, mode) => {
            return false
          }
        })

        $('#gender-search').dropdown()
        $('#marital-status-search').dropdown()
        $('#specialization-search').dropdown()

        $('#new-doctor-form').form({
          inline: true,
          on: 'blur',
          fields: {
            name: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter doctor name.'
                }
              ]
            },
            day: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Choose doctor date of birth.'
                }
              ]
            },
            gender: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please Choose doctor gender.'
                },
                {
                  type: 'integer[1..2]',
                  prompt: 'Please Choose valid option.'
                }
              ]
            },
            nationalId: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter doctor national ID.'
                },
                {
                  type: 'integer',
                  prompt: 'Please enter a valid national ID.'
                },
                {
                  type: 'minLength[13]',
                  prompt: 'Please enter a valid national ID with at least 13 character.'
                }
              ]
            },
            maritalStatus: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please choose doctor marital status.'
                },
                {
                  type: 'integer[1..2]',
                  prompt: 'Please Choose valid option.'
                }
              ]
            },
            // homePhone: {
            //   rules: [
            //     {
            //       type: 'empty',
            //       prompt: 'Please enter doctor home phone.'
            //     },
            //     {
            //       type: 'integer',
            //       prompt: 'Please enter valid home phone number.'
            //     },
            //     {
            //       type: 'minLength[7]',
            //       prompt: 'Please enter at least 7 numbers.'
            //     }
            //   ]
            // },
            cellPhone: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter doctor cell phone.'
                },
                {
                  type: 'integer',
                  prompt: 'Please enter valid cell phone number.'
                },
                {
                  type: 'minLength[11]',
                  prompt: 'Please enter valid cell phone number.'
                }
              ]
            },
            address: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter doctor address.'
                }
              ]
            },
            email: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter doctor email.'
                },
                {
                  type: 'email',
                  prompt: 'Please enter valid email.'
                }
              ]
            },
            password: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter doctor password.'
                },
                {
                  type: 'minLength[8]',
                  prompt: 'Please make the password length at least 8 characters.'
                }
              ]
            },
            passwordConfirmation: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter password confirmation.'
                },
                {
                  type: 'match[password]',
                  prompt: 'Your confirmation is not like the password you wrote.'
                }
              ]
            },
            specialization: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please enter doctor specialization.'
                },
                {
                  type: 'integer',
                  prompt: 'Please Choose valid option.'
                }
              ]
            }
          }
        })
      })
    },
    submit () {
      if ($('#new-doctor-form').form('is valid')) {
        this.loading = true
        this.$http.post('doctors', { doctor: this.doctor }).then(response => {
          this.loading = false
          this.notCreated = false
          this.navigateTo('Doctors')
        }).catch(error => {
          this.loading = false
          this.notCreated = true
        })
      }
    }
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
  .virtical-center {
    display: flex !important;
    align-items: center !important;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/doctors/NewDoctor.vue